import { useMindbodyWidgetsQuery } from 'app/data/queries/use-mindbody-widgets-query';
import { useWidgetSelector } from 'app/shared/hooks/use-widget-selector';
import { useMboWidgetModal } from 'app/shared/hooks/use-mbo-widget-modal';
import { MindbodyWidget } from 'app/pages/miniapp-mindbody/mindbody-widget';
import { MindbodyEmptyState } from 'app/pages/miniapp-mindbody/mindbody-empty-state';
import { MboWidgetModal } from 'app/components/mbo-widget-modal';

export const MiniappMindbodyPage = (): JSX.Element => {
  const { widgets, isLoading } = useMindbodyWidgetsQuery();
  const selectedIds = useWidgetSelector();

  // Registered once for the page rather than per widget — both takeovers are delegated, so a
  // single set of listeners covers every widget rendered below.
  const { state, close, resumeCart, reopenSignin } = useMboWidgetModal();

  // A utility button can target specific widgets via the comma-listed `widgetId`
  // param; with no selection we show every widget configured for the building.
  const visibleWidgets = selectedIds.length
    ? widgets.filter((widget) => widget.id && selectedIds.includes(widget.id))
    : widgets;

  return (
    <div data-testid="miniapp-mindbody" className="flex w-full flex-col gap-6">
      {!isLoading && visibleWidgets.length === 0 && <MindbodyEmptyState />}
      {visibleWidgets.map((widget, index) => (
        <MindbodyWidget key={widget.id ?? index} embed={widget.embed} />
      ))}
      <MboWidgetModal state={state} onClose={close} onResumeCart={resumeCart} onReopenSignin={reopenSignin} />
    </div>
  );
};
